import { useLocation } from "react-router-dom";
import TabLayout from "../components/tablayout/TabLayout";
import NoteViewPager from "./manage/NotePage";
import RecordViewPager from "./manage/RecordPage";
import { useEffect, useRef } from "react";

export default function ManagePage() {
	const location = useLocation();

	const tabLayoutRef = useRef();

	const tabData = [
		{ label: "Registra", icon: "home_pin", content: <RecordViewPager /> },
		{ label: "Note", icon: "note", content: <NoteViewPager /> },
	];

	useEffect(() => {
		if (location.hash && tabLayoutRef.current) {			
			tabLayoutRef.current.setActivePosition(
				location.hash === "#note" ? 1 : 0
			);
		}
	}, []);

	return <TabLayout ref={tabLayoutRef} tabs={tabData} isTopBar={false} />;
}
